import { apiUrl, apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  creatingUnitFile: false,
  uploadingBos: false,
  bosFile: null,
  showMarkSoldForm: false
}

const createUnitFilesSlice = (set, get) => ({
  ...initialState,
  createUnitFile: async(body, unitId) => {
    set((state) => ({ creatingUnitFile: true }))
    try {
      const response = await fetch(
        `${apiUrl}/unit-files`, {
        method: 'POST',
        headers: { 'Authorization': get().requestHeaders['Authorization']},
        body: body
        }
      )
      const data = await response.json()

      if (response.status === 200) {
        get().setSuccessMessage('Bill of Sale successfully uploaded')
        get().fetchUnit(unitId)
      }
    } catch (err) {
      get().setErrMessage('There was an error uploading this file.')
    } finally {
      set((state) => ({ creatingUnitFile: false }))
    }
  },
  setUploadingBos: (boolean) => {
    set((state) => ({uploadingBos: boolean}))
  },
  setBosFile: (file) => {
    set((state) => ({bosFile: file}))
  },
  setShowMarkSoldForm: (boolean) => {
    set((state) => ({showMarkSoldForm: boolean}))
  },
  resetUnitFilesSlice: () => set(initialState)
})

export default createUnitFilesSlice